import { cn } from "@/lib/utils";
import type { ConciergeStatus } from "@/lib/admin/concierge-api";

const STYLES: Record<ConciergeStatus, string> = {
  draft: "bg-muted text-muted-foreground border-border",
  published: "bg-primary/10 text-primary border-primary/20",
  archived: "bg-destructive/10 text-destructive border-destructive/20",
};

export function StatusBadge({ status }: { status: ConciergeStatus }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium capitalize",
        STYLES[status] ?? STYLES.draft,
      )}
    >
      {status}
    </span>
  );
}

export default StatusBadge;
